export default __webpack_public_path__ + "static/media/downarr.4a1543f6.png";